// src/services/lookups.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const lookupsApi = createApi({
  reducerPath: "lookupsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/lookups`,
    // If you need to attach a token, you can do so here:
    // prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("token");
    //   if (token) {
    //     headers.set("Authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
  }),
  endpoints: (builder) => ({
    getCities: builder.query({
      query: () => "/cities",
    }),
    getSchools: builder.query({
      query: () => "/schools",
    }),
    getSelectedByTypes: builder.query({
      query: () => "/selected-by-types",
    }),
    getFundsReleasedByTypes: builder.query({
      query: () => "/funds-released-by-types",
    }),
    getPriorities: builder.query({
      query: () => "/priorities",
    }),
    getAwards: builder.query({
      query: (scholarshipID) =>
        `/awards/history?scholarshipID=${scholarshipID}`,
      providesTags: ["AwardHistory"],
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useGetSchoolsQuery,
  useGetSelectedByTypesQuery,
  useGetFundsReleasedByTypesQuery,
  useGetPrioritiesQuery,
  useGetAwardsQuery,
} = lookupsApi;

export default lookupsApi;
export { lookupsApi };
